"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.delete.tooltip': 'Usuń konwersację',
    'conversations.delete.confirm': 'Czy na pewno chcesz usunąć "{title}"? Ta akcja nie może zostać cofnięta.',
    'conversations.delete.success': 'Konwersacja została pomyślnie usunięta',
    'conversations.delete.error': 'Nie udało się usunąć konwersacji',
    'conversations.delete.action': 'Usuń',
};
